require([
    'headroom.js/dist/headroom',
], Headroom => {
    const $win = $(window),
        $headroom = $('.headroom'),
        $headroomSpacing = $('.headroom-spacing'),
        classes = {
            initial: 'headroom--headroom',
            pinned: 'headroom--fixed',
            unpinned: 'headroom--unfixed',
            top: 'headroom--top',
            notTop: 'headroom--not-top',
        };

    let headroom;

    $win.on('resize', () => {
        if ($headroom.is('.headroom--fixed')) {
            $headroom.css('margin-top', 0);
        }

        $headroomSpacing.css('padding-top', $headroom.outerHeight());

        // trigger an event so that other components can act accordingly
        $win.data('initiallyResized', true).trigger('headroom.resized');
    }).trigger('resize');

    headroom = new Headroom($headroom[0], {
        offset: $headroom.height(),
        tolerance: 20, // mostly used for touch-pads/-screens
        classes,
        onTop() {
            $headroom
                .removeClass('headroom--fixed')
                .css('margin-top', 0);

            headroom.offset = $headroom.height();

            $headroomSpacing.css('padding-top', $headroom.outerHeight());
        },
        onPin() {
            headroom.offset = 0;

            $headroomSpacing.css('padding-top', $headroom.outerHeight());
        },
        onUnpin() {
            $headroom.css('margin-top', 0);
        },
    });

    headroom.init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/headroom.js